import { Directive } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ErrorService } from '@fb-tool-front/core/services/error.service';

@Directive({
  selector: '[appGtm]'
})
export class GtmDirective {
  constructor(private gtmService: GoogleTagManagerService, private errorSerivce: ErrorService) {
    this.gtmService
      .addGtmToDom()
      .catch(() => this.errorSerivce.logError('GTM is not initialized', 'warning'));
  }
}
